// 设备模板信息api
import request from '@/utils/request'
export const pageListApi = (data) => {
    return request({
        url: 'UserSpecialTasks/List',
        method: 'post',
        data
    })
}

export const detailApi = (data) => {
    return request({
        url: 'UserSpecialTasks/details',
        method: 'post',
        data
    })
}